import React, { useContext } from "react";

import Link from "next/link";

import { useTopbarContext } from "shared/providers/Layout/hooks/useTopbarContext";
import GlobalContext from "shared/providers/context/GlobalContext";
import { getGamificationCoinIcon } from "shared/utils/getGamificationCoinIcon";
import { useAuthContext } from "shared/utils/hooks/useAuthContext";
import { useFeature } from "shared/utils/hooks/useFeature";

import { ExpStarIcon } from "../../../assets/ExpStarIcon";
import { GamificationMenuInfosContainer } from "./styles";

const GamificationMenuInfos = () => {
  const { state } = useContext(GlobalContext);
  const { userCoins, userPoints } = useAuthContext();
  const isStoreFeatureFlagEnabled = useFeature("f_rewards_shop");

  const { closeFooterMobileMenu } = useTopbarContext();

  const gamificationData = state?.tenancy?.settings?.gamification;

  const isStoreEnabled = gamificationData?.enableRewardsShop == 1;
  const pointsNameAbbreviation = gamificationData?.pointsNameAbbreviation;
  const coinsColor = gamificationData?.coinsColor;
  const coinIcon = getGamificationCoinIcon(gamificationData?.coinsIcon);

  const isTriggersEnabled = gamificationData?.enableTriggers == 1;

  const formatedUserCoins = userCoins?.toLocaleString("pt-BR");
  const formatedUserPoints = userPoints?.toLocaleString("pt-BR");
  const shouldShowPoinstsName = formatedUserPoints?.length < 6;

  const shouldWarminUp = userPoints < 10;

  const shouldShowCoins =
    isStoreFeatureFlagEnabled &&
    isStoreEnabled &&
    typeof userCoins === "number";

  return (
    <GamificationMenuInfosContainer
      coinsColor={coinsColor}
      shouldWarminUp={shouldWarminUp}
    >
      <div className="coin-exp">
        {shouldShowCoins && (
          <div
            className="coins-section"
            onClick={
              shouldWarminUp && isTriggersEnabled
                ? () => window.open("/about-points", "_self")
                : null
            }
          >
            {coinIcon[0]?.icon} <p>{formatedUserCoins}</p>
          </div>
        )}
        {typeof userPoints === "number" && (
          <div
            className="exp-section"
            onClick={
              shouldWarminUp && isTriggersEnabled
                ? () => window.open("/about-points", "_self")
                : null
            }
          >
            <ExpStarIcon />
            <p>
              {formatedUserPoints}{" "}
              {shouldShowPoinstsName && pointsNameAbbreviation}
            </p>
          </div>
        )}
      </div>
      {isTriggersEnabled && (
        <button onClick={closeFooterMobileMenu}>
          <Link href={`/about-points`}>Como ganhar pontos?</Link>
        </button>
      )}
    </GamificationMenuInfosContainer>
  );
};

export default GamificationMenuInfos;
